var React = require('react');

function GreenCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm4.707-9.793a1 1 0 0 0-1.414-1.414L6.5 9.586 4.914 8A1 1 0 0 0 3.5 9.414l3 3 6.207-6.207z","fill":"#5FD800"}));
}

GreenCheck.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = GreenCheck;

GreenCheck.default = GreenCheck;
